import { CLIENTS_ACTIONS, initialClientsState } from './clients.types'

/**
 * @param {import('./clients.types').ClientsSlice} state
 * @param {import('./clients.types').ClientsAction} action
 * @returns {import('./clients.types').ClientsSlice}
 */
export function clientsReducer(state = initialClientsState, { type, payload }) {
  switch (type) {
    case CLIENTS_ACTIONS.SET_CLIENTS_STATUS:
      return {
        ...state,
        status: payload
      }

    case CLIENTS_ACTIONS.SET_CLIENTS_ERRORS:
      return {
        ...state,
        errors: [payload, ...state.errors]
      }

    case CLIENTS_ACTIONS.SET_CLIENT_OPTIONS:
      return {
        ...state,
        options: payload
      }

    default:
      return state
  }
}
